var _path, _path2, _animateTransform;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinnerPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25Z",
    fill: "#DDF0ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9343 8.56871C27.4455 9.80277 27.7764 11.1012 27.9192 12.4241C28.0084 13.2505 27.3262 13.9263 26.495 13.9263C25.6676 13.9263 25.0062 13.2547 24.8896 12.4356C24.2014 7.60175 20.3708 3.78023 15.5325 3.1058C14.6919 2.98862 14 2.31184 14 1.46309C14 0.614331 14.6901 -0.0824409 15.5337 0.010543C16.8457 0.155149 18.1333 0.48487 19.3576 0.991964C21.0561 1.69553 22.5995 2.72676 23.8995 4.02678C25.1995 5.3268 26.2307 6.87015 26.9343 8.56871Z",
    fill: "#00AB92"
  })), _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    from: "360 0 0",
    to: "0 0 0",
    attributeName: "transform",
    type: "rotate",
    repeatCount: "indefinite",
    dur: "2000ms"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinnerPrimary);
export default __webpack_public_path__ + "static/media/spinner-primary.5c125f2a3bc258d1e59bb518801e2bbd.svg";
export { ForwardRef as ReactComponent };